import { from, of } from "rxjs"
import { ofType } from "redux-observable"
import { switchMap, catchError } from "rxjs/operators"
import { push } from "connected-react-router"

import {
    fetchPlanShipmentDataSuccess,
    fetchTotalPlannedCarSuccess,
    updatePlanCountSuccess,
} from "./actions"
import { hideLoader } from "../loader/actions"
import calendarViewApi from "../../api/calendarview-api"
import * as types from "./actionTypes"
import * as errorActions from "../error/actions"

export function fetchAllCalendarData(action$) {
    return action$.pipe(
        ofType(types.FETCH_PLAN_SHIPMENT_DATA),
        switchMap((action) =>
            from(calendarViewApi.fetchPlanShipmentData(action.payload)).pipe(
                switchMap((data) =>
                    of(fetchPlanShipmentDataSuccess(data), hideLoader())
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}

export function fetchTotalPlannedCar(action$) {
    return action$.pipe(
        ofType(types.FETCH_PLAN_SHIPMENT_DATA),
        switchMap((action) =>
            from(calendarViewApi.fetchTotalPlannedCar(action.payload)).pipe(
                switchMap((data) =>
                    of(fetchTotalPlannedCarSuccess(data), hideLoader())
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}

export function updatePlanCount(action$) {
    return action$.pipe(
        ofType(types.UPDATE_PLAN_COUNT),
        switchMap((action) =>
            from(calendarViewApi.updatePlanCount(action.payload)).pipe(
                switchMap(() => of(updatePlanCountSuccess(), hideLoader())),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}
